import { AxiosResponse } from 'axios';
import { request } from '@cvt/clients/baseClient';
import { camelizeObject } from '@cvt/helpers/object';



const analysisApiBaseUrl = import.meta.env.VITE__CVT_API_URL;

const createStructuralAnalysis = (data: Partial<Stories.Edit>): Promise<AxiosResponse> => {
  return request({
    options: {
      url: `${analysisApiBaseUrl}/generate-structural-feedback/`,
      method: 'POST',
      data: {
        'story_id': data.id,
      },
    },
  });
};

const createContextualAnalysis = (data: Partial<Stories.StoryThrough>): Promise<AxiosResponse<Stories.StoryThrough>> => {
  return request({
    options: {
      url: `${analysisApiBaseUrl}/generate-contextual-feedback/`,
      method: 'POST',
      data: {
        'meeting_story_id': data.id,
        'meeting_adaptation': data.meetingAdaptation,
        'moment_of_reflection': data.momentOfReflection,
      },
    },
  }).then((data: AxiosResponse<Stories.StoryThroughApi>) => ({
    ...data,
    data: camelizeObject<Stories.StoryThrough>(data.data),
  }));
};

export const analysisClient = {
  createStructuralAnalysis: createStructuralAnalysis,
  createContextualAnalysis: createContextualAnalysis,

};
